import React, { useEffect, useState } from "react";
import Finance from "./Components/Finance";
import Property from "./Components/Property";
import Borrower from "./Components/Borrower";
import Checkbox from "../Components/Checkbox";
import Sidebar from "../Sidebar";
import { MdOutlineCheckCircle } from "react-icons/md";
import Results from "../Result/Results";
import Selection from "../Selection/selection";
import Hamburger from "hamburger-react";
import axios from "axios";
import * as Yup from "yup";
import Miscellaneous from "./Components/miscellaneous";
import lottie from "lottie-web";
import animationData from "../assets/Animation - 1713422214341.json";
import Loader from "../Components/Loader";
const Senario = (props) => {
  // State variables
  const [activeTab, setActiveTab] = useState("scenario");
  const [activeSideTab, setActiveSideTab] = useState("Financing");
  const [activeResultTab, setactiveResultTab] = useState("Eligible");
  const [activeButton, setActiveButton] = useState("First");
  const [activeButton1, setActiveButton1] = useState("Fixed");
  const [apiResponse, setApiResponse] = useState();
  const [isOpen, setOpen] = useState(false);
  const [errors, setErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lottieAnimation, setLottieAnimation] = useState(null);
  const [apiResponseReceived, setApiResponseReceived] = useState(false);
  // Function to handle click on next button
  const handleNextClick = () => {
    const tabs = ["Financing", "Property", "Borrower"];
    const currentIndex = tabs.indexOf(activeSideTab);
    const nextIndex = (currentIndex + 1) % tabs.length;
    setActiveSideTab(tabs[nextIndex]);
  };
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: document.getElementById("lottie-container"),
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
    });

    // Store the animation instance in state
    setLottieAnimation(anim);

    // Cleanup animation when component unmounts
    return () => {
      anim.destroy();
    };
  }, []);

  // Function to stop Lottie animation
  const stopLottieAnimation = () => {
    if (lottieAnimation) {
      lottieAnimation.stop();
    }
  };
  // Function to handle click on back button
  const handleBackClick = () => {
    const tabs = ["Financing", "Property", "Borrower"];
    const currentIndex = tabs.indexOf(activeSideTab);
    const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    setActiveSideTab(tabs[prevIndex]);
  };

  // Initial state for user query
  const [userQuery, setUserQuery] = useState({
    Lien_Position: "First",
    occupancy_status: "Primary Residence",
    Loan_purpose: "Purchase",
    amortization_type: "Fixed",
    term: "",
    First_Adjustment_Period: "",
    Property_Value: "",
    ltv: "",
    cltv: "",
    Base_loan_amount: "",
    other_financing: "",
    property_type: "SFH",
    state: "NY",
    city: "",
    zip: "",
    waive_escrows: false,
    citizenship: "US citizen",
    employment: false,
    doc_type: "Lite Doc",
    dscr: "",
    dti_ratio: "",
    credit_score: "",
    Mortgage_Type: "QM",
    bankruptcy_type: "",
    FTHB: false,
    LLC: false,
  });

  // User body for API request
  const userBody = {
    occupancy_status: userQuery.occupancy_status,
    amortization_type: userQuery.amortization_type,
    term: userQuery.term,
    ltv: parseInt(userQuery.ltv),
    cltv: parseInt(userQuery.cltv),
    property_type: userQuery.property_type,
    citizenship: userQuery.citizenship,
    doc_type: userQuery.doc_type,
    dti_ratio: parseInt(userQuery.dti_ratio),
    credit_score: parseInt(userQuery.credit_score),
  };
  console.log("userBody", userQuery);

  const userQuerySchema = Yup.object().shape({
    occupancy_status: Yup.string().required("Occupancy status is required"),
    amortization_type: Yup.string().required("Amortization type is required"),
    Property_Value: Yup.string().required("Property Value is required"),
    ltv: Yup.string().required("LTV is required"),
    cltv: Yup.string().required("CLTV is required"),
    property_type: Yup.string().required("Property type is required"),
    citizenship: Yup.string().required("Citizenship status is required"),
    doc_type: Yup.string().required("Document type is required"),
    dti_ratio: Yup.string().required("DTI ratio is required"),
    credit_score: Yup.string().required("Credit score is required"),
  });
  // Define Yup schema for user query data
  const userQuerySchemaFinance = Yup.object().shape({
    occupancy_status: Yup.string().required("Occupancy status is required"),
    amortization_type: Yup.string().required("Amortization type is required"),
    Property_Value: Yup.string().required("Property Value is required"),
    ltv: Yup.string().required("LTV is required"),
    cltv: Yup.string().required("CLTV is required"),
  });

  const userQuerySchemaTerm = Yup.object().shape({
    term: Yup.string().required("Term is required"),
  });

  const userQuerySchemaProperty = Yup.object().shape({});

  const userQuerySchemaProduct = Yup.object().shape({});

  const userQuerySchemaBorrower = Yup.object().shape({
    property_type: Yup.string().required("Property type is required"),
    citizenship: Yup.string().required("Citizenship status is required"),
    doc_type: Yup.string().required("Document type is required"),
    dti_ratio: Yup.string().required("DTI ratio is required"),
    credit_score: Yup.string().required("Credit score is required"),
  });

  const validateUserQuery = async (data) => {
    try {
      // Validate user query data against the schema
      await userQuerySchema.validate(data, { abortEarly: false });

      // If validation succeeds, return null
      return null;
    } catch (error) {
      // If validation fails, return an object containing error messages
      return error.inner.reduce((errors, err) => {
        return {
          ...errors,
          [err.path]: err.message,
        };
      }, {});
    }
  };

  // Function to validate user query data
  const validateUserQueryClick = async (data) => {
    try {
      // Validate user query data against the schema
      if (activeSideTab === "Financing") {
        await userQuerySchemaFinance.validate(data, { abortEarly: false });
        if (activeButton1 === "Fixed") {
          await userQuerySchemaTerm.validate(data, { abortEarly: false });
        }
      }
      if (activeSideTab === "Property") {
        await userQuerySchemaProperty.validate(data, { abortEarly: false });
      }
      if (activeSideTab === "Product") {
        await userQuerySchemaProduct.validate(data, { abortEarly: false });
      }
      if (activeSideTab === "Borrower") {
        await userQuerySchemaBorrower.validate(data, { abortEarly: false });
      }

      // If validation succeeds, return null
      return null;
    } catch (error) {
      // If validation fails, return an object containing error messages
      return error.inner.reduce((errors, err) => {
        return {
          ...errors,
          [err.path]: err.message,
        };
      }, {});
    }
  };

  const handleClick = async () => {
    // Validate user query data
    const validationErrors = await validateUserQueryClick(userQuery);
    // If there are validation errors, set the errors state
    if (validationErrors) {
      setErrors(validationErrors);
    } else {
      setErrors("");
      handleNextClick();
    }
  };

  // Example usage:
  const handleSubmit = async () => {
    // Validate user query data
    setIsLoading(true);
    const validationErrors = await validateUserQuery(userQuery);
    // If there are validation errors, set the errors state
    if (validationErrors) {
      setErrors(validationErrors);
    } else {
      setErrors("");
      // If validation succeeds, submit the form
      try {
        // Make the Axios POST request
        const response = await axios.post(
          "https://chloe-financial-python.onrender.com/check_eligibility",
          {
            user_query: userBody,
          }
        );

        // If request is successful, set active tab to results
        // if (response.status === 200) {
        if (response.data.status === 200) {
          setActiveTab("results");
          setIsLoading(false);
          console.log("sdfdsfdsf dsfdsfdsf");
          // stopLottieAnimation();
          // setApiResponse(response.data);
          // // Set apiResponseReceived to true
          // setApiResponseReceived(true);
        }
        console.log(response);
        // Set API response data
        setApiResponse(response.data);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        // Set isLoading to false regardless of whether the API call was successful or not
        setIsLoading(false);
      }
    }
  };

  // Function to handle menu toggle
  const handleMenu = () => {
    setOpen(!isOpen);
  };

  return (
    <>
      <Sidebar menu={isOpen}>
        <div className="bg-[#f8f9fc] h-screen relative z-10	 overflow-y-scroll  font-Poppins text-[#808080]  ">
          <div className="side-button" onClick={handleMenu}>
            <Hamburger />
          </div>

          <div className="bg-white py-6 px-4 xl:px-8 border-b border-[#E0E0E0]">
            {/* Header */}
            <div className="flex">
              <h1 className="text-black font-sm">Scenarios</h1>
              <p className="text-gray-400">/</p>
              <p className="text-gray-400">Loan #00000001</p>
            </div>

            {/* Validation and Run Scenario buttons */}
            <div className="flex justify-between  border-b py-6 px-1 w-full  max-[600px]:flex-col">
              <h1 className="text-[#2d2d2d] text-xl font-semibold">
                #00000001
              </h1>
              <div className="flex space-x-3 text-sm max-[600px]:mt-4">
                <button className="border border-[#ff6839] p-2 rounded-lg text-[#ff6839]">
                  Validation ({Object.keys(errors).length} issues)
                </button>
                <button
                  onClick={(e) => {
                    handleSubmit();
                  }}
                  className="bg-[#037dfa] p-2 rounded-lg text-white hover:text-[#037dfa] hover:bg-white hover:border hover:border-[#037dfa]"
                >
                  Run Scenario
                </button>
              </div>
            </div>

            {/* Tab navigation */}
            <ul className="flex py-2 space-x-8 px-2 text-lg">
              <li
                onClick={() => setActiveTab("scenario")}
                className={`cursor-pointer px-4 ${
                  activeTab === "scenario"
                    ? "text-black font-semibold border-b-4 border-[#037dfa] pb-3  "
                    : ""
                }`}
              >
                Scenario
              </li>
              <li
                onClick={
                  apiResponse != null ? () => setActiveTab("results") : null
                }
                className={`cursor-pointer px-4 ${
                  activeTab === "results"
                    ? "text-black font-semibold border-b-4 border-[#037dfa] pb-3  "
                    : ""
                }`}
              >
                Results
              </li>
              <li
                onClick={() => setActiveTab("History")}
                className={`cursor-pointer px-4 ${
                  activeTab === "History"
                    ? "text-black font-semibold border-b-4 border-[#037dfa] pb-3  "
                    : ""
                }`}
              >
                History
              </li>
              <button
                className="flex px-4"
                // onClick={() => setActiveTab("Testing")}
              >
                Notes
              </button>
            </ul>
          </div>

          {isLoading && Object.keys(errors).length === 0 && <Loader />}
          {/* Scenario tab */}
          {activeTab === "scenario" && (
            <div className="flex w-full h-auto flex-col md:flex-row max-[600px]:flex-col px-4 xl:px-8">
              {/* Scenario tab list */}

              <ul className=" mt-16 w-full flex flex-col space-y-2 text-base 2xl:flex-col md:w-1/5 lg:w-1/3 2xl:justify-start xl:text-lg  ">
                <li
                  onClick={() => setActiveSideTab("Financing")}
                  className={`cursor-pointer flex p-2 px-1 items-center  ${
                    activeSideTab === "Financing"
                      ? "text-white bg-[#0065cc]  mr-3 2xl:mr-8"
                      : "px-1 py-2"
                  }`}
                >
                  Financing Structure
                </li>
                <li
                  onClick={() => setActiveSideTab("Property")}
                  className={`cursor-pointer flex p-2 px-1 items-center ${
                    activeSideTab === "Property"
                      ? "text-white bg-[#0065cc]  mr-3 2xl:mr-8"
                      : "py-2"
                  }`}
                >
                  Property Information
                </li>

                <li
                  onClick={() => setActiveSideTab("Borrower")}
                  className={`cursor-pointer flex p-2 px-1 items-center ${
                    activeSideTab === "Borrower"
                      ? "text-white bg-[#0065cc]  mr-3 2xl:mr-8"
                      : "px-1 py-2"
                  }`}
                >
                  Borrower Information
                </li>

                <li
                  onClick={() => setActiveSideTab("Miscellaneous")}
                  className={`cursor-pointer flex p-2 px-1 items-center ${
                    activeSideTab === "Miscellaneous"
                      ? "text-white bg-[#0065cc] mr-3 2xl:mr-8"
                      : "px-1 py-2"
                  }`}
                >
                  Miscellaneous
                </li>
              </ul>

              {/* Render corresponding components based on active side tab */}
              <div className="mt-8 px-12 w-full 2xl:w-full flex flex-col  items-center border-l  text-sm xl:flex-end xl:text-base  ">
                {activeSideTab === "Financing" && (
                  <Finance
                    userQuery={userQuery}
                    setUserQuery={setUserQuery}
                    activeButton={activeButton}
                    setActiveButton={setActiveButton}
                    activeButton1={activeButton1}
                    setActiveButton1={setActiveButton1}
                    errors={errors}
                  />
                )}
                {activeSideTab === "Property" && (
                  <Property
                    userQuery={userQuery}
                    setUserQuery={setUserQuery}
                    activeButton={activeButton}
                    setActiveButton={setActiveButton}
                    errors={errors}
                  />
                )}
                {activeSideTab === "Borrower" && (
                  <Borrower
                    userQuery={userQuery}
                    setUserQuery={setUserQuery}
                    errors={errors}
                  />
                )}{" "}
                {activeSideTab === "Miscellaneous" && <Miscellaneous />}
                {/* Render navigation buttons */}
                {activeTab === "scenario" && (
                  <div
                    className={` w-full mt-16     pb-[100px] ${
                      activeSideTab === `Financing`
                        ? "flex  justify-end"
                        : "flex justify-between"
                    } `}
                  >
                    <button
                      onClick={handleBackClick}
                      className={` border-2	 border-[#037dfa] font-medium  hover:bg-[#037dfa] hover:text-white rounded-lg text-[#037dfa] py-4 w-[153px] ${
                        activeSideTab === `Financing` ? "hidden" : null
                      } `}
                    >
                      Back
                    </button>
                    <button
                      onClick={handleClick}
                      className={`hover:border   text-white font-medium hover:bg-white hover:border-[#037dfa] bg-[#037dfa] rounded-lg hover:text-[#037dfa] py-4 w-[153px] ${
                        activeSideTab === `Miscellaneous` ? "hidden" : null
                      }`}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Results tab */}
          {activeTab === "results" && (
            <div>
              <div className="flex w-full max-[600px]:flex-col h-auto 2xl:flex-row lg:flex-col px-4 xl:px-8">
                <ul className=" mt-8 w-full flex flex-col space-y-2 text-lg 2xl:flex-col 2xl:w-1/4 2xl:justify-start xl:text-lg xl:mt-20  ">
                  <li
                    onClick={() => setactiveResultTab("Eligible")}
                    className={`cursor-pointer flex items-center  ${
                      activeResultTab === "Eligible"
                        ? "text-white bg-[#0065cc]  p-2"
                        : "p-2"
                    }`}
                  >
                    Eligible
                  </li>
                  <li
                    onClick={() => setactiveResultTab("Ineligible")}
                    className={`cursor-pointer flex items-center ${
                      activeResultTab === "Ineligible"
                        ? "text-white bg-[#0065cc]  p-2"
                        : "p-2"
                    }`}
                  >
                    Ineligible
                  </li>
                </ul>

                <div className="mt-8 w-full  2xl:w-full flex flex-col justify-center   h-auto text-sm xl:flex-end  xl:text-base xl:mt-20 ">
                  <Results
                    apiResponse={apiResponse}
                    setApiResponse={setApiResponse}
                    activeResultTab={activeResultTab}
                  />
                </div>
              </div>
            </div>
          )}

          {/* History tab */}
          {activeTab === "History" && (
            <div>
              <div className="flex w-full h-auto px-4 xl:px-8">
                <div className="mt-8 w-full flex flex-col justify-center items-end h-auto ">
                  <div className="w-full pb-5 max-[600px]:w-full">
                    {activeTab === "History" && <Selection />}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Sidebar>
    </>
  );
};

export default Senario;
